import { action } from 'easy-peasy';

const checkFinishReport = {
    finish: false,
    setFinish: action((state, payload) => {
        state.finish = payload;
    }),
};

export default checkFinishReport;